export default __webpack_public_path__ + "static/media/jane-churchyard-screengrab-10.fa1dd242.jpg";